import { render } from "./ExpertValidation.vue?vue&type=template&id=4e2344f5&scoped=true&ts=true"
import script from "./ExpertValidation.vue?vue&type=script&lang=ts"
export * from "./ExpertValidation.vue?vue&type=script&lang=ts"

import "./ExpertValidation.vue?vue&type=style&index=0&id=4e2344f5&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\wotruba\\IdeaProjects\\fungus_data_tool\\frontend-vue3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e2344f5"]])

export default __exports__